import { api } from './api'

/**
 * Descarcă un XLSX de la endpoint-ul dat (cu params query).
 * Browser-ul îl salvează cu numele din header Content-Disposition.
 *
 * Timeout extins (5 min) pentru exporturi mari (zeci de mii de rânduri).
 */
export async function downloadXlsx(url: string, fallbackName = 'export.xlsx'): Promise<void> {
  const response = await api.get(url, {
    responseType: 'blob',
    timeout: 5 * 60_000,
  })
  const blob = response.data as Blob

  // Verifică dacă e XLSX valid (nu eroare JSON sub forma de blob)
  if (
    blob.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
    blob.type !== 'application/octet-stream' &&
    blob.size < 5_000
  ) {
    // probabil e eroare JSON
    const text = await blob.text()
    try {
      const err = JSON.parse(text) as { error?: { message?: string } }
      throw new Error(err.error?.message ?? text)
    } catch {
      throw new Error(text || 'Export invalid')
    }
  }

  // Try to extract filename from Content-Disposition
  let filename = fallbackName
  const cd = response.headers['content-disposition']
  if (cd) {
    const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(cd)
    if (match) filename = decodeURIComponent(match[1])
  }

  const downloadUrl = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = downloadUrl
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(downloadUrl)
}
